//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import UBT from '@/utils/ubt';
import {
  getRentalRecord,
  rentalRecordConfirm,
} from '@/api/rentBike';

export default {
  data() {
    const fullYear = new Date().getFullYear();
    const m = new Date().getMonth() + 1;
    const fullMonth = m < 10 ? `0${m}` : m;
    const queryDate = `${fullYear}-${fullMonth}-01 00:00:00`;
    return {
      arrowStatus: true,
      rentalMobile: '',
      tableData: [],
      isFocus: false,
      fullMonth,
      fullYear,
      pageIndex: 1,
      pageSize: 15,
      scrollStop: false,
      queryDate,
    };
  },
  computed: {
    ...mapState({
      promotionUserId: state => state.user.loginResult.promotionUserId || '1',
    }),
    delIcon() {
      return !!this.rentalMobile;
    },
  },
  mounted() {
    UBT.pageView({
      pageId: 'H5_换电_租车记录页',
    });
    this.renderPage();
    this.$nextTick(() => {
      const dom = document.querySelector('.rent-list');
      if (dom) {
        dom.addEventListener('scroll', (e) => {
          if (this.scrollStop) return;
          const {
            offsetHeight,
            scrollTop,
            scrollHeight
          } = e.srcElement;
          if (scrollHeight - offsetHeight - 10 < scrollTop) {
            this.pageIndex += 1;
            this.renderPage();
          }
        });
      }
    });
  },
  methods: {
    renderPage(option) {
      getRentalRecord({
        queryDate: this.queryDate,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        rentalMobile: this.rentalMobile,
      }).then((res) => {
        if (option === 'search' && res.data && res.data.list.length === 0) {
          this.$vux.toast.text('该手机号无租车记录', 'center');
        } else {
          if (res.data.list && res.data.list.length === 0) {
            this.scrollStop = true;
            return;
          }
          this.scrollStop = false;
          this.tableData = this.tableData.concat(res.data.list || []);
          this.$nextTick(() => {
            this.tableData.forEach((item) => {
              const htmlFontSize = document.documentElement.style.fontSize.slice(0, -2) * 1;
              const ofh = this.$refs[`remark_${item.rentalRecordId}`][0];
              if (ofh.offsetHeight / htmlFontSize <= 1) {
                this.$set(item, 'hideRemark', false);
              } else {
                this.$set(item, 'hideRemark', true);
              }
            });
          });
        }
      });
    },

    toggleRemark(item) {
      this.$set(item, 'remarkFullShow', !item.remarkFullShow);
    },

    focusHandle() {
      this.isFocus = true;
    },

    resetSearch() {
      this.rentalMobile = '';
      this.isFocus = false;
      this.tableData = [];
      this.pageIndex = 1;
      this.renderPage();
    },

    searchHandle() {
      if (this.rentalMobile && !/^1[3456789]\d{9}$/.test(this.rentalMobile)) {
        this.$vux.alert.show({
          title: '提示',
          content: '请输入正确的手机号',
        });
      } else {
        this.tableData = [];
        this.pageIndex = 1;
        this.renderPage('search');
      }
    },

    onChange() {
      const that = this;
      this.arrowStatus = false;
      this.$vux.datetime.show({
        cancelText: '取消',
        confirmText: '确定',
        format: 'YYYY-MM',
        value: `${this.fullYear}-${this.fullMonth}`,
        onHide() {
          that.arrowStatus = true;
        },
        onConfirm(date) {
          that.arrowStatus = true;
          if (date !== `${that.fullYear}-${that.fullMonth}`) {
            [that.fullYear, that.fullMonth] = date.split('-');
            that.tableData = [];
            that.pageIndex = 1;
            that.queryDate = `${date}-01 00:00:00`;
            that.renderPage();
          }
        },
      });
    },

    btnHandle({ rentalRecordId, rentalStatus, rentalMobile }) {
      if (rentalStatus === 2) return;
      // 显示
      this.$vux.confirm.show({
        title: '',
        confirmText: '确定收回',
        cancelText: '点错了',
        content: `确认将${rentalMobile}的车收回吗`,
        onConfirm: () => {
          UBT.pageView({
            pageId: 'H5_换电_确认收车弹窗',
          });
          rentalRecordConfirm({ rentalRecordId }).then((res) => {
            if (res.code === 0) {
              // const record = this.tableData.find(item => item.rentalRecordId === rentalRecordId);
              // record.rentalStatus = 2; //eslint-disable-line
              this.resetSearch();
            }
          });
        }
      });
    },


    addhandle() {
      UBT.clickButton({
        pageId: 'H5_换电_租车记录页',
        buttonName: 'H5_换电_租车记录页_添加记录',
      });
      this.$router.push({
        name: 'rentForm',
      });
    },
  },
};
